export default [
    {
        path: '/team',
        name: 'authMode_setting_team',
        meta: {
            access: ['AUTH_SETTING_TEAM'],
            title: 'authMode_setting_team',
            icon: 'icon-kehu',
            notPageView: true,
        },
        redirect: { name: 'authMode_setting_team_list' },
        component: () => import(/* webpackChunkName: "setting2" */ '@/views/main/authMode/Setting/Team/index.vue'),
        children: [
            {
                path: 'list',
                name: 'authMode_setting_team_list',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_TEAM'],
                    title: 'authMode_setting_team',
                    icon: 'icon-kehu',
                },
                component: () => import(/* webpackChunkName: "setting2" */'@/views/main/authMode/Setting/Team/List.vue'),
            },
            {
                path: 'member',
                name: 'authMode_setting_team_member',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_TEAM'],
                    title: 'authMode_setting_team',
                    icon: 'icon-kehu',
                },
                component: () => import(/* webpackChunkName: "setting2" */'@/views/main/authMode/Setting/Team/List.vue'),
            },
            {
                path: 'role',
                name: 'authMode_setting_team_role',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_TEAM'],
                    title: 'authMode_setting_team',
                    icon: 'icon-kehu',
                },
                component: () => import(/* webpackChunkName: "setting2" */'@/views/main/authMode/Setting/Team/List.vue'),
            },
            {
                path: 'create/:id*',
                name: 'authMode_setting_team_create',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_TEAM'],
                    title: 'authMode_setting_team',
                    icon: 'icon-kehu',
                },
                component: () => import(/* webpackChunkName: "setting2" */'@/views/main/authMode/Setting/Team/CreateRole/index.vue'),
            },
        ],
    },
    {
        path: '/setting',
        name: 'authMode_setting',
        meta: {
            access: ['AUTH_SETTING'],
            title: 'authMode_setting',
            icon: 'icon-shezhi',
            notPageView: true,
        },
        component: () => import(/* webpackChunkName: "setting2" */ '@/views/main/authMode/Setting/index.vue'),
        // redirect: { name: 'authMode_setting_project_management' },
        children: [
            // 应用商店
            {
                path: 'appstore',
                name: 'appstore',
                meta: {
                    access: ['AUTH_APPLICATION_CENTER'],
                    title: 'appstore',
                    icon: 'icon-gongju',
                },
                component: () => import('@/views/main/ApplicationStore/index.vue'),
            },
            {
                path: 'appstore/apply/:id*',
                name: 'automation_ai_robot_apply',
                meta: {
                    access: ['AUTH_APPLICATION_CENTER'],
                    title: 'appstore',
                    icon: 'icon-gongju',
                    hideInMenu: true,
                    documentTitle: 'appstore',
                    activeMenu: 'appstore',
                },
                component: () => import(/* webpackChunkName: "robot" */ '@/views/main/automation/Robot/Apply/index.vue'),
            },
            {
                path: 'project_management',
                name: 'authMode_setting_project_management',
                meta: {
                    access: ['AUTH_SETTING_ONLINE_CHAT'],
                    title: 'authMode_setting_project_management',
                    icon: 'icon-shezhi',
                    notPageView: true,
                },
                component: () => import(/* webpackChunkName: "setting2" */ '@/views/main/setting/ProjectManagement/index.vue'),
                children: [
                    {
                        path: 'chat_installation',
                        name: 'authMode_setting_project_management_chat',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_SETTING_ONLINE_CHAT'],
                            title: 'authMode_setting_project_management_chat',
                            icon: 'icon-shezhi',
                        },
                        component: () => import(/* webpackChunkName: "setting2" */ '@/views/main/setting/ProjectManagement/ChatInstallation/index.vue'),
                    },
                    {
                        path: 'chat_tool_installation',
                        name: 'authMode_setting_project_management_chat_tool',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_SETTING_ONLINE_CHAT'],
                            title: 'authMode_setting_project_management_chat_tool',
                            icon: 'icon-shezhi',
                        },
                        component: () => import(/* webpackChunkName: "setting2" */ '@/views/main/setting/ProjectManagement/ChatToolInstallation/index.vue'),
                    },
                    {
                        path: 'custom_fields_installation',
                        name: 'authMode_setting_project_management_custom_fields',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_SETTING_ONLINE_CHAT'],
                            title: 'authMode_setting_project_management_custom_fields',
                            icon: 'icon-shezhi',
                        },
                        component: () => import(/* webpackChunkName: "setting2" */ '@/views/main/setting/ProjectManagement/CustomFields/index.vue'),
                    },
                    {
                        path: 'development_installation',
                        name: 'authMode_setting_project_management_development',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_SETTING_ONLINE_CHAT'],
                            title: 'authMode_setting_project_management_development',
                            icon: 'icon-shezhi',
                        },
                        component: () => import(/* webpackChunkName: "setting2" */ '@/views/main/setting/ProjectManagement/DevelopmentInstallation/index.vue'),
                    },
                    {
                        path: 'project_installation',
                        name: 'authMode_setting_project_management_project',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_SETTING_ONLINE_CHAT'],
                            title: 'authMode_setting_project_management_project',
                            icon: 'icon-shezhi',
                        },
                        component: () => import(/* webpackChunkName: "setting2" */ '@/views/main/setting/ProjectManagement/ProjectInstallation/index.vue'),
                    },
                ],
            },
            {
                path: 'fee',
                name: 'authMode_setting_fee',
                meta: {
                    access: ['AUTH_SETTING_COST_CENTER'],
                    title: 'authMode_setting_fee',
                    icon: 'icon-shezhi',
                    hideInMenu: true,
                },
                redirect: { name: 'fee' },
            },
            {
                path: 'mobile',
                name: 'authMode_setting_mobile',
                meta: {
                    title: 'authMode_setting_mobile',
                    icon: 'icon-shezhi',
                },
            },
            {
                path: 'log',
                name: 'authMode_setting_log',
                meta: {
                    access: ['AUTH_LOGIN_LOG'],
                    title: 'authMode_setting_log',
                    icon: 'icon-shezhi',
                    notPageView: true,
                },
                redirect: { name: 'authMode_setting_log_login' },
                component: () => import(/* webpackChunkName: "setting2" */ '@/views/main/authMode/Setting/LoginLog/index.vue'),
                children: [
                    {
                        path: 'login',
                        name: 'authMode_setting_log_login',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_LOGIN_LOG'],
                            title: 'authMode_setting_log',
                            icon: 'icon-shezhi',
                        },
                        component: () => import(/* webpackChunkName: "setting2" */ '@/views/main/authMode/Setting/LoginLog/LoginLogList.vue'),
                    },
                    {
                        path: 'online',
                        name: 'authMode_setting_log_online',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_LOGIN_LOG'],
                            title: 'authMode_setting_log',
                            icon: 'icon-shezhi',
                        },
                        component: () => import(/* webpackChunkName: "setting2" */ '@/views/main/authMode/Setting/LoginLog/OnlineLogList.vue'),
                    },
                    {
                        path: 'operate',
                        name: 'authMode_setting_log_operate',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_LOGIN_LOG'],
                            title: 'authMode_setting_log',
                            icon: 'icon-shezhi',
                        },
                        component: () => import(/* webpackChunkName: "setting2" */ '@/views/main/authMode/Setting/LoginLog/OperateLogList.vue'),
                    },
                ],
            },
            // todo 旧路由重定向跳转兼容，待删除
            {
                path: 'chat',
                name: 'setting_chat',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'setting_chat',
                    icon: 'icon-shezhi',
                },
                redirect: { name: 'channels_chat_list' },
                children: [
                    {
                        path: 'list',
                        name: 'setting_chat_list',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'setting_chat_list',
                            icon: 'icon-shezhi',
                        },
                        redirect: { name: 'channels_chat_list' },
                    },
                    {
                        path: 'new',
                        name: 'setting_chat_new',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'setting_chat_list',
                            icon: 'icon-shezhi',
                        },
                        redirect: { name: 'channels_chat_new' },
                    },
                    {
                        path: ':id',
                        name: 'setting_chat_edit',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'setting_chat_edit',
                            icon: 'icon-shezhi',
                        },
                        redirect: { name: 'channels_chat_edit' },
                    },
                ],
            },
            {
                path: 'messenger',
                name: 'setting_messenger',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'setting_messenger',
                },
                redirect: { name: 'channels_messenger_page' },
                children: [
                    {
                        path: 'auth',
                        name: 'authMode_auth',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'authMode_auth',
                            icon: 'icon-shezhi',
                        },
                        redirect: { name: 'channels_messenger_auth' },
                    },
                    {
                        path: 'page',
                        name: 'authMode_page',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'authMode_page',
                            icon: 'icon-shezhi',
                        },
                        redirect: { name: 'channels_messenger_page' },
                    },
                ],
            },
            {
                path: 'email',
                name: 'setting_email',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'setting_email',
                    icon: 'icon-shezhi',
                },
                redirect: { name: 'channels_email' },
            },
            {
                path: 'instagram',
                name: 'setting_instagram',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'setting_instagram',
                    icon: 'icon-shezhi',
                },
                redirect: { name: 'channels_instagram' },
            },
            {
                path: 'telegram',
                name: 'setting_telegram',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'setting_telegram',
                    icon: 'icon-shezhi',
                },
                redirect: { name: 'channels_telegram' },
            },
            {
                path: 'line',
                name: 'setting_line',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'setting_line',
                    icon: 'icon-shezhi',
                },
                redirect: { name: 'channels_line' },
            },
            {
                path: 'whatsapp',
                name: 'setting_whatsapp',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'setting_whatsapp',
                    icon: 'icon-shezhi',
                },
                component: () => import(/* webpackChunkName: "setting" */ '@/views/main/Channels/Whatsapp/index.vue'),
                redirect: { name: 'channels_whatsapp_platform' },
                children: [
                    {
                        path: 'platform',
                        name: 'setting_whatsapp_platform',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'setting_whatsapp',
                            icon: 'icon-shezhi',
                        },
                        redirect: { name: 'channels_whatsapp_platform' },
                    },
                    {
                        path: 'business',
                        name: 'setting_whatsapp_business',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'setting_whatsapp',
                            icon: 'icon-shezhi',
                        },
                        redirect: { name: 'channels_whatsapp_business' },
                    },
                    {
                        path: 'cloud',
                        name: 'setting_whatsapp_cloud',
                        meta: {
                            access: ['AUTH_SETTING_CHANNEL'],
                            title: 'setting_whatsapp',
                            icon: 'icon-shezhi',
                        },
                        redirect: { name: 'channels_whatsapp_cloud' },
                    },
                ],
            },
            {
                path: 'whatsapp/bill',
                name: 'setting_whatsapp_bill',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'setting_whatsapp_bill',
                    icon: 'icon-shezhi',
                },
                redirect: { name: 'channels_whatsapp_bill' },
            },
            {
                path: 'slack',
                name: 'setting_slack',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_CHANNEL'],
                    title: 'setting_slack',
                    icon: 'icon-shezhi',
                },
                redirect: { name: 'channels_slack' },
            },
            {
                path: 'visitor_tags',
                name: 'authMode_setting_visitor_tags',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_SESSION_TAG'],
                    title: 'authMode_setting_visitor_tags',
                    icon: 'icon-shezhi',
                },
                redirect: { name: 'contact_tags_management' },
            },
            {
                path: 'fee',
                name: 'setting_fee',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_COST_CENTER'],
                    title: 'setting_fee',
                    icon: 'icon-shezhi',
                },
                redirect: { name: 'authMode_setting_fee' },
            },
            {
                path: 'general_chat',
                name: 'setting_general_chat',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_ONLINE_CHAT'],
                    title: 'setting_general_chat',
                    icon: 'icon-shezhi',
                },
                redirect: { name: 'authMode_setting_general_chat' },
            },
            {
                path: 'general_chat',
                name: 'authMode_setting_general_chat',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_ONLINE_CHAT'],
                    title: 'authMode_setting_general_chat',
                    icon: 'icon-shezhi',
                },
                redirect: { name: 'authMode_setting_project_management_chat' },
            },
            {
                path: 'setting_session_tags',
                name: 'setting_session_tags',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_CHAT_MANAGEMENT'],
                    title: 'setting_session_tags',
                    icon: 'icon-shezhi',
                },
                redirect: { name: 'contact_tags_session' },
            },
            {
                path: 'project',
                name: 'setting_project',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_PROJECT'],
                    title: 'setting_project',
                    icon: 'icon-shezhi',
                },
                redirect: { name: 'authMode_setting_project' },
            },
            {
                path: 'project',
                name: 'authMode_setting_project',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_PROJECT'],
                    title: 'authMode_setting_project',
                    icon: 'icon-shezhi',
                },
                redirect: { name: 'authMode_setting_project_management_project' },
            },
            {
                path: 'mobile',
                name: 'setting_mobile',
                meta: {
                    hideInMenu: true,
                    title: 'setting_mobile',
                    icon: 'icon-shezhi',
                },
                redirect: { name: 'authMode_setting_mobile' },
            },
            // todo 旧路由重定向跳转兼容，待删除
            {
                path: 'team',
                name: 'setting_team_redirect',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_SETTING_TEAM'],
                    title: 'authMode_setting_team',
                    icon: 'icon-kehu',
                },
                redirect: { name: 'authMode_setting_team_list' },
                children: [
                    {
                        path: 'list',
                        name: 'setting_team_list_redirect',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_SETTING_TEAM'],
                            title: 'authMode_setting_team',
                        },
                        redirect: { name: 'authMode_setting_team_list' },
                    },
                    {
                        path: 'member',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_SETTING_TEAM'],
                            title: 'authMode_setting_team',
                        },
                        redirect: { name: 'authMode_setting_team_member' },
                    },
                    {
                        path: 'role',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_SETTING_TEAM'],
                            title: 'authMode_setting_team',
                        },
                        redirect: { name: 'authMode_setting_team_role' },
                    },
                    {
                        path: 'create/:id*',
                        name: 'setting_team_create_redirect',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_SETTING_TEAM'],
                            title: 'authMode_setting_team',
                        },
                        redirect: { name: 'authMode_setting_team_create' },
                    },
                ],
            },
        ],
    },
];
